import React from 'react';

import './ManageBonus.css';
import { BONUS_PAGES } from './constants';

import ErrorFeedbackBar from '../../global/ErrorFeedbackBar';
import FeedbackBar from '../../feedbackBar/FeedbackBar';
import withShipment from '../../../withShipment';
import { statusSelector } from '../../../redux/selectors/global';
import { clearStatus } from '../../../redux/actions/global';
import { userInfoSelector } from '../../../redux/selectors/auth';
import {
  deleteManageBonus,
  listManageBonus,
  saveManageBonus,
  toggleManageBonus,
} from '../../../redux/actions/settings';
import { manageBonusSelector } from '../../../redux/selectors/settings';

import BonusList from './BonusList';
import EditBonus from './EditBonus';
import { downloadBonusSchedulePdf } from './bonusPdf';

function canEdit(bonus, user) {
  return !bonus.createdBy || bonus.createdBy === user.userId;
}

class ManageBonus extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      currentPage: BONUS_PAGES.TABLE,
      editBonus: null,
      readOnly: false,
      feedbackBarOpen: false,
      feedbackStatus: '',
      feedbackMessage: '',
    };
  }

  componentDidMount() {
    this.props.listManageBonus({ locationId: this.props.user.selectedLocationId });
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.status.statusText &&
      prevProps.status.statusText !== this.props.status.statusText
    ) {
      this.openFeedbackBar('error', this.props.status.statusText);
    }
  }

  openFeedbackBar = (status, message) =>
    this.setState({ feedbackStatus: status, feedbackMessage: message, feedbackBarOpen: true });

  closeFeedbackBar = () =>
    this.setState(
      { feedbackBarOpen: false, feedbackStatus: '', feedbackMessage: '' },
      () => this.props.clearStatus()
    );

  handleOpen = (bonus) =>
    this.setState({
      editBonus: bonus,
      readOnly: !canEdit(bonus, this.props.user),
      currentPage: BONUS_PAGES.FORM,
    });

  handleNew = () =>
    this.setState({ editBonus: null, readOnly: false, currentPage: BONUS_PAGES.FORM });

  handleEditingClear = () =>
    this.setState({ editBonus: null, readOnly: false, currentPage: BONUS_PAGES.TABLE });

  handleToggle = (bonus, nextActive) =>
    this.props.toggleManageBonus(
      { manageBonusId: bonus.manageBonusId, enabled: nextActive },
      (err, message) => {
        if (err) this.openFeedbackBar('error', message || 'Could not update bonus');
      }
    );

  handleDelete = (manageBonusId) =>
    this.props.deleteManageBonus({ manageBonusId });

  handleDownloadPdf = () => {
    const bonuses = this.props.bonus || [];
    if (bonuses.length === 0) {
      this.openFeedbackBar('error', 'No bonuses to export');
      return;
    }
    downloadBonusSchedulePdf(
      bonuses,
      this.props.user.selectedLocationName || 'Location'
    );
  };

  render() {
    const { currentPage, editBonus, readOnly } = this.state;
    return (
      <React.Fragment>
        <ErrorFeedbackBar />
        <FeedbackBar
          open={this.state.feedbackBarOpen}
          handleClose={this.closeFeedbackBar}
          severity={this.state.feedbackStatus}
          message={this.state.feedbackMessage}
        />

        {currentPage === BONUS_PAGES.FORM ? (
          <EditBonus
            user={this.props.user}
            editBonus={editBonus}
            readOnly={readOnly}
            saveBonus={this.props.saveManageBonus}
            handleDelete={this.handleDelete}
            handleEditingClear={this.handleEditingClear}
            openFeedbackBar={this.openFeedbackBar}
          />
        ) : (
          <BonusList
            bonuses={this.props.bonus}
            user={this.props.user}
            onOpen={this.handleOpen}
            onNew={this.handleNew}
            onToggle={this.handleToggle}
            onDownloadPdf={this.handleDownloadPdf}
          />
        )}
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  status: statusSelector(state),
  user: userInfoSelector(state),
  bonus: manageBonusSelector(state),
});

const actionCreators = {
  clearStatus,
  saveManageBonus,
  listManageBonus,
  deleteManageBonus,
  toggleManageBonus,
};

export default withShipment({ actionCreators, mapStateToProps }, ManageBonus);
